// Training partners, the app side: wording for the partner card. The rules
// (targets, freezes, the streak) live on the API in lib/partners.js.

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const firstName = (name) => (name || "").trim().split(/\s+/)[0] || "Your partner";

const days = (n) => `${n} more ${n === 1 ? "day" : "days"}`;

/**
 * Where this week stands, in one line: who still needs how many days, or
 * that the week counts.
 */
export const describeWeek = (thisWeek, partnerName) => {
  if (!thisWeek) return "";
  const them = firstName(partnerName);
  const myGap = Math.max(0, thisWeek.me.target - thisWeek.me.days);
  const theirGap = Math.max(0, thisWeek.them.target - thisWeek.them.days);
  if (!myGap && !theirGap) return "You're both there. This week counts.";
  if (myGap && theirGap) return `You need ${days(myGap)}, ${them} needs ${days(theirGap)}.`;
  if (myGap) return `${them}'s there. You need ${days(myGap)}.`;
  return `You're there. ${them} needs ${days(theirGap)}.`;
};

/** "Freeze ready for October", or that this month's has gone. */
export const describeFreeze = (available, weekStart) => {
  const month = weekStart ? MONTHS[Number(weekStart.slice(5, 7)) - 1] : "this month";
  return available ? `Freeze ready for ${month}` : `${month}'s freeze used`;
};

/** "4-week streak", "No streak yet". */
export const describeStreak = (n) => (n > 0 ? `${n}-week streak` : "No streak yet");

/** How full a person's bar is this week, 0–100. */
export const weekPct = ({ days, target }) => (target > 0 ? Math.min(100, Math.round((days / target) * 100)) : 0);
